import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from "react";
import { useAssetModalPanel } from "~/components/AssetModalV2/AssetModalPanelsContextProvider";
export const AssetModalContentDesktopLayout = /*#__PURE__*/ memo((param)=>{
    let { header, content, leftPanel, footer } = param;
    const { showContentLeftPanel } = useAssetModalPanel();
    return /*#__PURE__*/ _jsxs("div", {
        className: "grid size-full grid-rows-[auto_1fr_auto]",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-span-full flex h-16 items-center p-4 text-grey-10",
                children: header
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: showContentLeftPanel ? "grid min-h-0 grid-cols-[264px_1fr]" : "grid min-h-0 grid-cols-1",
                children: [
                    showContentLeftPanel && /*#__PURE__*/ _jsx("div", {
                        className: "min-h-0 px-4 py-2",
                        children: leftPanel
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex min-h-0 flex-col p-6",
                        children: content
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-span-full flex h-16 items-center p-4 text-grey-10",
                children: footer
            })
        ]
    });
});
AssetModalContentDesktopLayout.displayName = "AssetModalContentDesktopLayout";
